import { Injectable } from '@angular/core';

import { Http, RequestOptions, Headers } from '@angular/http';

export type InternalStateType = {
  [key: string]: any
};

@Injectable()
export class AppState {
  public ScrollMagic : any;
  public controller : any;
  public controllerMain : any;
  public _state: InternalStateType = { };
  public all_fees : any;

  constructor(private http: Http){
    this.ScrollMagic = require("scrollmagic");
    require("scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap");
    this.controller = new this.ScrollMagic.Controller();
    this.controllerMain = new this.ScrollMagic.Controller();  
    this.all_fees = {
      tiger: {
        experience_20: "180",
        experience_30: "245",
        experience_40: "310",
        normal: "240"
      },
      cub:{
        normal: "155"
      },
      turb:{
        normal: "80"
      },
      cap:{
        experience_20: "180",
        normal: "240"
      },
      formation:{ 
        normal: "160"
      },
      membership: {
        full: "250",
        overseas: "130",
        temp: "65",
        associate: "80",
        youth: "125"
      },
      last_updated: "1st September 2021",
      year: "2020"
    };
   }







  /**
   * Already return a clone of the current state.
   */
  public get state() {
    return this._state = this._clone(this._state);
  }
  /**
   * Never allow mutation
   */
  public set state(value) {
    throw new Error('do not mutate the `.state` directly');
  }

  public send_email(body:any, pdf:any = 0){

    var url = "https://api.postmarkapp.com/email/withTemplate";

    var obj = {
      safety_check: "2av8ishere",
      pdf: pdf,
      content: body
    }
    //console.log("OBJECT SENT IS : ", obj);
     return this.http.post("https://tigerclub.co.uk/assets/emails/website2.php", obj);

   }


   public buy_voucher(body:any){

     var obj = {
      safety_check: "2av8ishere2",
      content: body
    }

     return this.http.post("https://tigerclub.co.uk/assets/emails/website2.php", obj);

   }

   public buy_membership(body:any){

      var obj = {
        safety_check: "2av8ishere4",
        content: body
      }

      return this.http.post("https://tigerclub.co.uk/assets/emails/website2.php", obj);

   }

   public get_super_secret_token(body:any){

    var obj = {
      safety_check: "2av8ishere3",
      content: body
    }

     return this.http.post("https://tigerclub.co.uk/assets/emails/website2.php", obj);
   }

  public get(prop?: any) {
    /**
     * Use our state getter for the clone.
     */
    const state = this.state;
    return state.hasOwnProperty(prop) ? state[prop] : state;
  }

  public getFees() {
    /**
     * Use our state getter for the clone.
     */
    const state = this.all_fees;
    return state;
  }

  public set(prop: string, value: any) {
    /**
     * Internally mutate our state.
     */
    return this._state[prop] = value;
  }

  private _clone(object: InternalStateType) {
    /**
     * Simple object clone.
     */
    return JSON.parse(JSON.stringify( object ));
  }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/app.service.ts